import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-addpet',
  templateUrl: './addpet.component.html',
  styleUrls: ['./addpet.component.css']
})
export class AddpetComponent implements OnInit {
  dob: any;
  uid: any;
  petregistrationform: any;
  loading = false;
  msg1: any;
  action: any;
  image: any;
  bio: any;
  constructor( public form: FormBuilder, private commonService: CommonService,
  private doctorService: DoctorService, private router: Router , private  snackbar: MatSnackBar) {
    this.petregistrationform = this.form.group({
      'Pet_name': new FormControl('', Validators.required),
      'Pet_type': new FormControl('', Validators.required),
      });
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
  }
  ngOnInit() {
  }
  doRegister() {
    this.bio = 'About Me';
    this.loading = true;
         if (this.petregistrationform.Pet_type === 'dog') {
             this.image = 'dogavatar.png';
           }
         if (this.petregistrationform.Pet_type === 'cat') {
           this.image = 'catavatar.png';
          }
          if (this.petregistrationform.Pet_type === 'Birds') {
            this.image = 'catavatar.png';
          }
          if (this.petregistrationform.Pet_type === 'Rabbit/Hamsters') {
            this.image = 'catavatar.png';
          }
          if (this.petregistrationform.Pet_type === 'Others') {
            this.image = 'dogavatar.png';
          }
          if (!this.dob) {
            this.dob ="0000-00-00";
          }
    this.doctorService.createuserPetDetail(this.uid,
      this.petregistrationform.Pet_name, this.petregistrationform.Pet_type, this.dob ,this.image,this.bio)
    .subscribe(
      (x) => {
        this.loading =false;
        this.msg1 ='Pet Registration Successfully';
        this.openSnackBar();
       this.router.navigate(['/manageprofile/manageyourpet']);
      });
  }
  openSnackBar() {
    this.snackbar.open(this.msg1 , this.action, {
      duration: 4000,
    });
   }
}
